module.exports = __webpack_public_path__ + "static/media/Livestock-thumbnail.5d6e637a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ToolCard/thumbnails/Livestock-thumbnail.png
// module id = 1217
// module chunks = 0